import { v4 as uuidv4 } from 'uuid';
import { IDiningSessionPayload, IDinningSession } from './interface';
import { qlubSessionStorage } from '../storage/sessionStorage';

const session: {
    id: string | undefined;
} = {
    id: undefined,
};

const diningSession: {
    list: { [key: string]: IDiningSessionPayload };
} = {
    list: {},
};

const defaultJwt: {
    params: IDinningSession | undefined;
} = {
    params: undefined,
};

function getDefaultJwtKey() {
    return 'qlub.default_jwt';
}

function getSessionKey() {
    return 'qlub.session';
}

export function getSession(defaultSessionId?: string) {
    if (defaultSessionId) {
        session.id = defaultSessionId;
        return defaultSessionId;
    }
    if (session.id) {
        return session.id || '1';
    }
    const s = qlubSessionStorage.get(getSessionKey());
    if (s) {
        session.id = s;
    } else {
        session.id = uuidv4();
        qlubSessionStorage.set(getSessionKey(), session.id);
    }
    return session.id || '1';
}

function getDiningSessionKey(params: IDinningSession) {
    return `qlub.dining_session.${params.slug}_${params.id}_${params.f1 || ''}_${params.f2 || ''}_${
        params.hash || ''
    }_${params.qsr || ''}_${params.qOrderId || ''}_${params.qsrPayment || ''}`;
}

export function getDiningSession(params: IDinningSession): IDiningSessionPayload | undefined {
    const key = getDiningSessionKey(params);
    defaultJwt.params = params;
    qlubSessionStorage.set(getDefaultJwtKey(), JSON.stringify(params));
    if (diningSession.list.hasOwnProperty(key)) {
        return diningSession.list[key];
    }
    const payload = qlubSessionStorage.get(key);
    if (payload) {
        diningSession.list[key] = JSON.parse(payload);
    }
    return diningSession.list[key];
}

export function setDiningSession(params: IDinningSession, payload: IDiningSessionPayload) {
    const key = getDiningSessionKey(params);
    qlubSessionStorage.set(key, JSON.stringify(payload));
    diningSession.list[key] = payload;
}

export function removeDiningSession(params: IDinningSession) {
    const key = getDiningSessionKey(params);
    qlubSessionStorage.remove(key);
    delete diningSession.list[key];
}

export function getDefaultJwt() {
    const paramsStr = qlubSessionStorage.get(getDefaultJwtKey());
    if (paramsStr) {
        const param: IDinningSession = JSON.parse(paramsStr);
        const t = getDiningSession(param);
        if (t) {
            return t.jwt;
        }
    }
    return null;
}
